export const BOARD_NAME_URL_ERROR_MESSAGE_MOBILE = 'Board name contains a URL';
export const BOARD_NAME_URL_ERROR_MESSAGE_DESKTOP = "You can't share a board with a URL in its name";
